import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { isNative } from '@/shared/lib/platform';

export const useBackButton = () => {
  useEffect(() => {
    if (!isNative()) {
      return;
    }

    const setup = async () => {
      return App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack || window.history.length > 1) {
          window.history.back();
          return;
        }

        App.exitApp();
      });
    };

    const subscription = setup();

    return () => {
      void subscription.then(async (handle) => {
        await handle.remove();
      });
    };
  }, []);
};
